import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 1,
  class: "toast__reaction"
}
const _hoisted_3 = { class: "toast__name" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")

  return (_openBlock(), _createBlock(_component_TransitionWrapper, {
    class: "toaster",
    name: "toast",
    tag: "ul",
    group: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.toasts, (toast) => {
        return (_openBlock(), _createElementBlock("li", {
          key: toast.seed,
          class: "toast",
          style: _normalizeStyle($options.styled(toast.name, toast.seed))
        }, [
          (toast.reactionURL)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "toast__reaction-img",
                src: toast.reactionURL,
                alt: toast.reaction,
                width: "34",
                height: "34"
              }, null, 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(toast.reaction), 1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(toast.name), 1)
        ], 4))
      }), 128))
    ]),
    _: 1
  }))
}